import { createContext } from '@shared/utils/createContext';

type SearchColorwayOrder = ReadonlyMap<string, ReadonlyArray<string>>;

/**
 * Per-theme colorway ordering for the active gallery search: themeId → colorway
 * ids that cleared the search threshold, best-match first. Tiles use it to sort
 * their swatches (best first) and preselect the top one. Swatches are never
 * hidden — colorways absent from this list render after the ranked ones.
 *
 * `strict: false` because the context is intentionally absent outside the
 * designs gallery (e.g. favorites), where tiles behave as "no active search".
 */
const [SearchColorwayOrderProvider, useSearchColorwayOrderContext] = createContext<SearchColorwayOrder>({
  name: 'SearchColorwayOrderContext',
  strict: false,
});

export { SearchColorwayOrderProvider };

export function useSearchColorwayOrder(themeId: string): ReadonlyArray<string> | undefined {
  const order = useSearchColorwayOrderContext();
  return order?.get(themeId);
}
